import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<g id=\"exclude\"><path id=\".fill .fade\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M5.5 2.5C3.84315 2.5 2.5 3.84314 2.5 5.5V13.0714C2.5 14.7283 3.84314 16.0714 5.5 16.0714H7.92858V19C7.92858 20.3807 9.04787 21.5 10.4286 21.5H19C20.3807 21.5 21.5 20.3807 21.5 19V10.4286C21.5 9.04785 20.3807 7.92857 19 7.92857H16.0714V5.5C16.0714 3.84315 14.7283 2.5 13.0714 2.5H5.5ZM16.0714 7.92857H10.4286C9.04787 7.92857 7.92858 9.04785 7.92858 10.4286V16.0714H13.0714C14.7283 16.0714 16.0714 14.7283 16.0714 13.0714V7.92857Z\"></path><g id=\"Group Copy\"><rect id=\"Rectangle\" x=\"2.75\" y=\"2.75\" width=\"13.0455\" height=\"13.0455\" rx=\"2.25\" stroke-linecap=\"round\"></rect><rect id=\"Rectangle Copy\" x=\"8.20453\" y=\"8.20456\" width=\"13.0455\" height=\"13.0455\" rx=\"2.25\" stroke-linecap=\"round\"></rect></g></g>", 1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }